import * as affiliate from 'src/api/affiliates'
import router from 'src/router'
import {
  GET_ALL_AFFILIATES,
  GET_AFFILIATE
} from 'src/store/mutation-types'

const getAllAffiliates = ({commit, dispatch}, params = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  affiliate.getAllAffiliates(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_AFFILIATES, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_AFFILIATES, [])
    }
  })
}

const getAffiliate = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  affiliate.getAffiliate(configs.id, configs.params).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_AFFILIATE, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Affiliate không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'affiliate'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setAffiliate = ({commit}, affiliate) => {
  commit(GET_AFFILIATE, affiliate)
}

export default {
  getAllAffiliates,
  getAffiliate,
  setAffiliate
}



// WEBPACK FOOTER //
// ./src/components/affiliate/store/actions.js